"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _APSwitch = _interopRequireDefault(require("../../../../common/APSwitch/APSwitch"));
var _APButton = _interopRequireDefault(require("../../../../common/APButton"));
var _Enable2FAModalContainer = _interopRequireDefault(require("../../../../EnableTwoFactorAuth/Enable2FAModalContainer"));
var _Disable2FAModalContainer = _interopRequireDefault(require("../../../../EnableTwoFactorAuth/Disable2FAModalContainer"));
var _GetGoogle2FARecoveryKeyModalContainer = _interopRequireDefault(require("../../../../EnableTwoFactorAuth/GetGoogle2FARecoveryKeyModalContainer"));
var _cssClassesHelper = require("../../../../../helpers/cssClassesHelper");
var _userConfigConstants = require("../../../../../constants/userConfigConstants");
require("./EnableTwoFactorAuthComponent.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var bemClasses = (0, _cssClassesHelper.getBEMClasses)('settings-enable-two-factor-auth');
var EnableTwoFactorAuthComponent = function EnableTwoFactorAuthComponent(props) {
  var _useTranslation = (0, _reactI18next.useTranslation)("auth"),
    t = _useTranslation.t;
  var handleClick = function handleClick(newValue) {
    if (newValue) {
      props.disable2FA();
    } else {
      props.enable2FA();
    }
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses()
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('on-off-2fa-container')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('switch')
  }, /*#__PURE__*/_react["default"].createElement(_APSwitch["default"], {
    name: "use2FA",
    onClick: handleClick
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('info')
  }, /*#__PURE__*/_react["default"].createElement("p", null, t("Two-Factor Authentication (2FA) adds another layer of protection to your account by requiring an additional passcode during the logging in process.")), props.TwoFAType !== _userConfigConstants.TwoFaTypes.Yubico && /*#__PURE__*/_react["default"].createElement("p", null, t("You will need to download Google Authenticator on your smartphone as part of the process to enable 2FA.")))), props.showRecoverySeed && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_APButton["default"], {
    name: "recovery2FA",
    customClass: bemClasses(),
    onClick: props.getGoogle2FARecoveryKey
  }, t("Recovery"))), /*#__PURE__*/_react["default"].createElement(_Enable2FAModalContainer["default"], null), /*#__PURE__*/_react["default"].createElement(_Disable2FAModalContainer["default"], null), /*#__PURE__*/_react["default"].createElement(_GetGoogle2FARecoveryKeyModalContainer["default"], null));
};
EnableTwoFactorAuthComponent.propTypes = {
  getGoogle2FARecoveryKey: _propTypes["default"].func.isRequired,
  disable2FA: _propTypes["default"].func.isRequired,
  enable2FA: _propTypes["default"].func.isRequired,
  showRecoverySeed: _propTypes["default"].bool.isRequired,
  TwoFAType: _propTypes["default"].string
};
var _default = exports["default"] = EnableTwoFactorAuthComponent;